function isCurrentDocumentTypeIsFluidDocument() {
    // TODO - use correct documentType - https://jira.wixpress.com/browse/HTMLSRVR-5585
    // @ts-expect-error
    return window.editorModel.siteHeader.documentType === 'fluidDocument';
}
export { isCurrentDocumentTypeIsFluidDocument };
